import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getEventImages, getArchivedEventImages, archiveEventImage, restoreEventImage } from '../../api/event-images';
import { getLevelEvents } from '../../api/level-events';
import EntityArtManager from '../EntityArtManager/EntityArtManager';
import './EventsArt.scss';
const EventsArt = ({ levelId, refreshTrigger, nodes }) => {
    // eventId → the map cell that carries it, so the badge can name the linked cell.
    const coordByEventId = useMemo(() => {
        var _a;
        const m = new Map();
        for (const [coord, data] of Object.entries(nodes !== null && nodes !== void 0 ? nodes : {})) {
            for (const se of (_a = data.simpleEvents) !== null && _a !== void 0 ? _a : [])
                m.set(se.eventId, coord);
        }
        return m;
    }, [nodes]);
    const linkage = useMemo(() => ({
        strategy: 'sequential',
        load: getLevelEvents,
        loadErrorMessage: 'Failed to load events for images linkage',
        describeLinks: (img, events) => {
            // An event uses this image as its background (large) OR its card (small) — match both.
            const linked = events.filter(e => e.backgroundImage === img.imageUrl || e.cardImage === img.imageUrl);
            const coords = [...new Set(linked.map(e => coordByEventId.get(e.id)).filter((c) => !!c))];
            return {
                count: linked.length,
                badgeText: linked.length > 0 ? `${linked.length}` : '',
                // Hover shows WHICH cell(s) use this art; falls back to the count when the
                // linked events aren't cell-bound (shouldn't happen for authored levels).
                badgeTitle: coords.length
                    ? `Cell${coords.length > 1 ? 's' : ''} ${coords.join(', ')}`
                    : `${linked.length} linked event${linked.length !== 1 ? 's' : ''}`,
            };
        },
    }), [coordByEventId]);
    return (_jsx(EntityArtManager, { levelId: levelId, refreshTrigger: refreshTrigger, title: "Event Images", containerClassName: "events-art-container", listImages: getEventImages, listArchivedImages: getArchivedEventImages, archiveImage: archiveEventImage, restoreImage: restoreEventImage, linkage: linkage }));
};
export default EventsArt;
